import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import moment from 'moment';

import { DateBox, NumberBox, SelectBox, TextArea } from 'devextreme-react';

import { useLazyGetComingNomenclatureMaterialsQuery } from 'bus/comingNomenclatureMain/services/services';
import { ComingNomenclatureMaterial } from 'bus/comingNomenclatureMain/types';
import {
  useChangeConsumptionNomenclatureMutation,
  useCreateConsumptionNomenclatureMutation,
  useLazyGetConsumptionNomenclatureDetailQuery,
} from 'bus/consumptionNomenclature/services/services';
import { useGetFactoryFullNamesQuery } from 'bus/factory/services/services';

import { ConsumptionNomenclatureDetail } from '../../../../../../bus/consumptionNomenclature/types';
import { AppGroup, AppRow } from '../../../../../../components/appComponents';
import AppFiledBox from '../../../../../../components/appComponents/app-field-box';
import ModalFooter from '../../../../../../components/appModalFooter';
import $createDataSource from '../../../../../../utils/create-data-souce-instance';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
};

const initialForm: ConsumptionNomenclatureDetail = {
  id: null,
  date: moment(new Date()).format('YYYY-MM-DDTHH:mm'),
  nomenclatureId: null,
  factoryId: null,
  unitId: null,
  quantity: 0,
  comment: '',
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id }) => {
  let createFacroryGroupValidationRef = useRef<ValidationGroup>(null);
  const [unitList, setUnitList] = useState<Array<ComingNomenclatureMaterial>>([]);

  const [getComingNomenclatureMaterials] = useLazyGetComingNomenclatureMaterialsQuery();
  const [getConsumptionNomenclatureDetail] = useLazyGetConsumptionNomenclatureDetailQuery();
  const [createConsumptionNomenclature] = useCreateConsumptionNomenclatureMutation();
  const [changeConsumptionNomenclature] = useChangeConsumptionNomenclatureMutation();
  const { data } = useGetFactoryFullNamesQuery();

  const [form, setForm] = useState<ConsumptionNomenclatureDetail>(initialForm);
  const [loading, setLoading] = useState(false);

  const storeMaterial: any = useMemo(() => {
    return $createDataSource('/v1/Material', 'id');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onShown = async () => {
    if (id) {
      const result = await getConsumptionNomenclatureDetail({ id }).unwrap();
      getComingNomenclatureMaterials({ id: result.nomenclatureId! }).unwrap().then(setUnitList);
      setForm(result);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createFacroryGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    setLoading(true);
    e.preventDefault && e.preventDefault();

    if (createFacroryGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeConsumptionNomenclature(form);
      } else {
        const tempForm = { ...form };
        delete tempForm.id;
        await createConsumptionNomenclature(tempForm);
      }
      changeVisible(false);
      refresh();
    }
    setLoading(false);
  };

  const handleChangeMaterial = (itemData: any) => {
    setForm((prev) => ({ ...prev, nomenclatureId: itemData.id, unitId: itemData.unitId }));
    getComingNomenclatureMaterials({ id: itemData.id }).unwrap().then(setUnitList);
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Расход материалов"
        width={700}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createFacroryGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Площадка" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            items={data}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.factoryId}
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, factoryId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Площадку" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Площадку" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, date: e as string }));
                            }}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            value={form.date}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label="Материал" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeMaterial}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.nomenclatureId}
                            onItemClick={(e) => handleChangeMaterial(e.itemData)}
                          >
                            <DropDownOptions title="Выберите материал" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите материал" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Ед. изм." labelTop>
                          <div className="d-flex align-center">
                            <SelectBox
                              stylingMode="underlined"
                              style={{ width: '100%' }}
                              items={unitList}
                              displayExpr="name"
                              valueExpr="id"
                              value={form.unitId}
                              onValueChange={(e) => {
                                setForm((prev) => ({ ...prev, unitId: e }));
                              }}
                            >
                              <DropDownOptions title="Выберите Ед. изм." closeOnOutsideClick={true} showTitle={false} />
                              <Validator>
                                <RequiredRule message="Выберите Ед. изм." />
                              </Validator>
                            </SelectBox>
                          </div>
                        </AppFiledBox>

                        <AppFiledBox label="Объем" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Объем"
                            format="####0.##"
                            value={form.quantity}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, quantity: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Объем" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={loading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
